import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
export const PersonCircleIcon = ({ color, style, }) => {
    const theme = useTheme();
    const bgColor = theme.colors.white;
    const strokeColor = color ?? theme.colors.azure;
    const styles = {
        borderRadius: '50%',
        border: `4px solid ${bgColor}`,
        background: `${bgColor}`,
        width: '40px',
        height: '40px',
        ...style,
    };
    return (_jsxs("svg", { fill: bgColor, viewBox: "0 0 32 32", style: styles, children: [_jsx("circle", { cx: "16", cy: "16", r: "12.333", stroke: strokeColor, strokeWidth: "2" }), _jsx("path", { d: "m5.6611 24.309c1.7096-3.5951 5.6588-5.6341 10.257-5.6341 4.5988 0 8.5481 2.0391 10.258 5.6342-0.4616 0.5636-0.9687 1.0885-1.5157 1.569-0.431-1.2445-1.1731-2.2656-2.1309-3.0654-1.5983-1.3345-3.9095-2.1378-6.611-2.1378-2.7014 0-5.0126 0.8033-6.6109 2.1378-0.95784 0.7998-1.6999 1.8208-2.1309 3.0653-0.54702-0.4805-1.0541-1.0054-1.5157-1.569z", clipRule: "evenodd", fill: strokeColor, fillRule: "evenodd" }), _jsx("circle", { cx: "15.918", cy: "12.26", r: "3.7747", stroke: strokeColor, strokeWidth: "2" })] }));
};
//# sourceMappingURL=person_circle_icon.js.map